import BaseTrackResumeEventTask from "../../../../../shared/src/ranj/equalture/platform/BaseTrackResumeEventTask";
import ProgressValue from "../../../../../shared/src/ranj/equalture/platform/ProgressValue";
import BaseSaveModel from "../../../../../shared/src/ranj/equalture/savegame/BaseSaveModel";
import TrackingController from "../model/TrackingController";

export default class TrackResumeEventTask extends BaseTrackResumeEventTask {
    /**
     * @constructor
     * @param {BaseSaveModel} saveModel
     * @param {TrackingController} trackingController
     */
    constructor(saveModel, trackingController) {
        super();

        this._saveModel = saveModel;
        this._trackingController = trackingController;
    }

    trackResumeEvent() {
        super.trackResumeEvent();

        const elapsedTime = this._saveModel.getSaveGame()?.elapsedTime;
        this._trackingController.trackProgress(ProgressValue.RESUMED, elapsedTime);
    }
}